<script>
	import { img_prefix } from 'shared/var'
	import { onMount } from 'svelte'

	const loadout_img_prefix = `${ img_prefix }/training/rifle-class/`

	const loadouts = [
		{
			img: `Rifle Class Pics-1022.jpg`,
			name: `Classic Suppressed MK18`,
			bullets: [
				`<a href="https://www.trex-arms.com/store/Lightbar-Scout-Mount/?attribute_pa_Rail-type=Picatinny">Picatinny Lightbar Scout Mount</a>`,
				`Modlite 18650 `,
				`<a href="https://www.trex-arms.com/store/l3-insight-atpial-c-ir-laser/">L3/Insight ATPIAL-C IR Laser</a>`,
				`<a href="https://www.trex-arms.com/?s=vertical&post_type=product&paged=0">BCM Vertical Grip</a> `,
				`<a href="https://www.trex-arms.com/store/eotech-exps3-0/">EOTECH EXPS3-0</a> `,
				`<a href="https://www.trex-arms.com/store/New-Sling/">T.REX ARMS Sling</a>`,
				`Surefire Socom556-RC2 Suppressor`,
				`Knight's Armament Backup Iron Sights `,
				`<a href="https://www.trex-arms.com/store/Radian-Weapons-Raptor-Charging-Handle/">Radian Raptor Charging Handle</a> `,
			],
		},
		{
			img: `Rifle Class Pics-1083.jpg`,
			name: `13.7 Rifle Build`,
			bullets: [
				`<a href="https://www.trex-arms.com/store/surefire-three-prong-flash-hider/">Surefire Three Prong Flash Hider</a>`,
				`<a href="https://www.trex-arms.com/store/surefire-m600v-scout-ir-illuminator/">Surefire M600V Scout IR Illuminator</a>`,
				`L3/Insight NGAL IR Laser/Illuminator `,
				`Modlite Modbutton Lite`,
				`<a href="https://www.trex-arms.com/store/eotech-exps3-0/">EOTECH EXPS3-0</a>`,
				`<a href="https://www.trex-arms.com/store/eotech-g33-magnifier/">EOTECH G33 Magnifier</a>`,
				`<a href="https://www.trex-arms.com/store/Radian-Weapons-Raptor-Charging-Handle/">Radian Raptor Charging Handle</a> `,
				`<a href="https://www.trex-arms.com/store/New-Sling/">T.REX ARMS Sling</a>`,
			],
		},
		{
			img: `Rifle Class Pics-1090.jpg`,
			name: `Simple Stag 16” Rifle`,
			bullets: [
				`Modlite 18350`,
				`<a href="https://www.trex-arms.com/store/Lightbar-Scout-Mount/?attribute_pa_Rail-type=KeyMod">Keymod Lightbar Scout Mount</a>`,
				`<a href="https://www.trex-arms.com/store/Aimpoint-Patrol-Rifle-Optic-PRO/">Aimpoint PRO</a>`,
				`<a href="https://www.trex-arms.com/store/surefire-st07-scout-mini-pressure-pad/">Surefire ST07 Pressure Pad</a>`,
				`<a href="https://www.trex-arms.com/store/New-Sling/">T.REX ARMS Sling</a> `,
				`Magpul MBUS Backup Iron Sights`,
			],
		},
		{
			img: `Rifle Class Pics-1102.jpg`,
			name: `10.3 Mini Recce`,
			bullets: [
				`Surefire Socom556-RC2 Suppressor`,
				`<a href="https://www.trex-arms.com/?s=vertical&post_type=product&paged=0">BCM Vertical Grip</a>`,
				`<a href="https://www.trex-arms.com/store/Scalarworks-Scope-LEAP/?attribute_pa_Co-witness-height=1-93">Scalarworks 1.93 Scope Mount</a> `,
				`<a href="https://www.trex-arms.com/store/EOTech-Vudu-1-8x24-SFP-Riflescope-HC3-Reticle-MOA/">EOTECH Vudu 1-8</a>`,
				`<a href="https://www.trex-arms.com/store/law-folder-ar-m4-gen-3/">Law Tactical Folder</a> `,
				`<a href="https://www.trex-arms.com/store/T-REX-Offset-Mount/?attribute_pa_Model=Delta-Point-Pro">T.REX ARMS Deltapoint Offset Mount</a>`,
				`<a href="https://www.trex-arms.com/store/leupold-deltapoint-pro/">Leupold Deltapoint Pro</a>`,
				`<a href="https://www.trex-arms.com/store/Radian-Weapons-Raptor-Charging-Handle/">Radian Raptor Charging Handle</a> `,
				`<a href="https://www.trex-arms.com/store/New-Sling/">T.REX ARMS Sling</a>`,
				`Modlite Modbutton Lite `,
			],
		},
		{
			img: `Rifle Class Pics-1118.jpg`,
			name: `10.5 AR Pistol Build`,
			bullets: [
				`<a href="https://www.trex-arms.com/store/surefire-warcomp/">Surefire Warcomp</a>`,
				`<a href="https://www.trex-arms.com/store/l3-insight-atpial-c-ir-laser/">L3/Insight ATPIAL-C IR Laser</a>`,
				`<a href="https://www.trex-arms.com/store/eotech-exps3-0/">EOTECH EXPS3-0</a>`,
				`Magpul MBUS Pro Backup Iron Sights`,
				`<a href="https://www.trex-arms.com/store/Radian-Weapons-Raptor-Charging-Handle/">Radian Raptor Charging Handle</a>`,
				`<a href="https://www.trex-arms.com/store/New-Sling/">T.REX ARMS Sling</a> `,
			],
		},
		{
			img: `Rifle Class Pics-1129.jpg`,
			name: `BCM 11.5 AR Pistol`,
			bullets: [
				`<a href="https://www.trex-arms.com/store/surefire-m600u-scout/">Surefire M600U Scout Light</a>`,
				`<a href="https://www.trex-arms.com/store/surefire-three-prong-flash-hider/">Surefire Three Prong Flash Hider</a>`,
				`<a href="https://www.trex-arms.com/store/surefire-sr07-scout-rail-compatible-pressure-pad/">Surefire SR07 Pressure Pad</a>`,
				`<a href="https://www.trex-arms.com/?s=vertical&post_type=product&paged=0">BCM Vertical Grip</a>`,
				`<a href="https://www.trex-arms.com/store/Aimpoint-Patrol-Rifle-Optic-PRO/">Aimpoint PRO</a>`,
				`Magpul MBUS Backup Iron Sights`,
				`<a href="https://www.trex-arms.com/store/New-Sling/">T.REX ARMS Sling</a> `,
				`<a href="https://www.trex-arms.com/store/Radian-Weapons-Raptor-Charging-Handle/">Radian Raptor Charging Handle</a>`,
			],
		},
		{
			img: `Rifle Class Pics-1139.jpg`,
			name: `Modern MK18`,
			bullets: [
				`<a href="https://www.trex-arms.com/store/surefire-three-prong-flash-hider/">Surefire Three Prong Flash Hider</a>`,
				`<a href="https://www.trex-arms.com/store/l3-insight-atpial-c-ir-laser/">L3/Insight ATPIAL-C IR Laser</a>`,
				`Modlite 18650`,
				`<a href="https://www.trex-arms.com/store/scalarworks-aimpoint-leap/?attribute_pa_Co-witness-height=1-93">Scalarworks Aimpoint LEAP 1.93</a>`,
				`<a href="https://www.trex-arms.com/store/aimpoint-t2/">Aimpoint T2</a>`,
				`<a href="https://www.trex-arms.com/store/Lightbar-Scout-Mount/?attribute_pa_Rail-type=Picatinny">Picatinny Lightbar Scout Mount</a> `,
				`<a href="https://www.trex-arms.com/store/Radian-Weapons-Raptor-Charging-Handle/">Radian Raptor Charging Handle</a> `,
				`<a href="https://www.trex-arms.com/store/New-Sling/">T.REX ARMS Sling</a>`,
			],
		},
		{
			img: `Rifle Class Pics-02850.jpg`,
			name: `Suppressed BCM 11.5 Pistol`,
			bullets: [
				`Griffin Armament M4SD Suppressor`,
				`<a href="https://www.trex-arms.com/store/arisaka-45-degree-surefire-scout-mount/">Arisaka 45 Degree Scout Mount</a> `,
				`Modlite 18350`,
				`<a href="https://www.trex-arms.com/?s=vertical&post_type=product&paged=0">BCM Vertical Grip</a>`,
				`<a href="https://www.trex-arms.com/store/scalarworks-aimpoint-leap/?attribute_pa_Co-witness-height=1-93">Scalarworks Aimpoint LEAP 1.93</a> `,
				`<a href="https://www.trex-arms.com/store/aimpoint-t2/">Aimpoint T2</a>`,
				`<a href="https://www.trex-arms.com/store/Radian-Weapons-Raptor-Charging-Handle/">Radian Raptor Charging Handle</a>`,
				`<a href="https://www.trex-arms.com/store/Magpul-B-A-D-Lever/">Magpul BAD Lever</a> `,
				`<a href="https://www.trex-arms.com/store/New-Sling/">T.REX ARMS Sling</a>`,
			],
		},
		{
			img: `Rifle Class Pics-02858.jpg`,
			name: `Classic 14.5” Cheese-Grater`,
			bullets: [
				`<a href="https://www.trex-arms.com/store/surefire-sr07-scout-rail-compatible-pressure-pad/">Surefire SR07 Pressure Pad</a>`,
				`<a href="https://www.trex-arms.com/?s=vertical&post_type=product&paged=0">BCM Vertical Grip</a>`,
				`<a href="https://www.trex-arms.com/store/scalarworks-aimpoint-leap/?attribute_pa_Co-witness-height=Lower-Third">Scalarworks Aimpoint LEAP</a> `,
				`<a href="https://www.trex-arms.com/store/aimpoint-t2/">Aimpoint T2</a>`,
				`<a href="https://www.trex-arms.com/store/New-Sling/">T.REX ARMS Sling</a>`,
			],
		},
		{
			img: `Rifle Class Pics-02915.jpg`,
			name: `10.3 FSB Build`,
			bullets: [
				`<a href="https://www.trex-arms.com/store/surefire-m600u-scout/">Surefire M600U Scout Light</a>`,
				`<a href="https://www.trex-arms.com/?s=vertical&post_type=product&paged=0">BCM Vertical Grip</a>`,
				`<a href="https://www.trex-arms.com/store/IWC-45-Offset-QD-Mount/">IWC 45 Offset QD mount</a> `,
				`<a href="https://www.trex-arms.com/store/eotech-exps3-0/">EOTECH EXPS3-0</a>`,
				`<a href="https://www.trex-arms.com/store/Radian-Weapons-Raptor-Charging-Handle/">Radian Raptor Charging Handle</a>`,
				`<a href="https://www.trex-arms.com/store/New-Sling/">T.REX ARMS Sling</a>`,
				`Modlite Modbutton Lite `,
			],
		},
		{
			img: `Rifle Class Pics-02922.jpg`,
			name: `Folding Stag 16” Rifle`,
			bullets: [
				`<a href="https://www.trex-arms.com/store/surefire-m300c-mini-scout/">Surefire M300C Mini Scout Light</a>`,
				`<a href="https://www.trex-arms.com/store/Aimpoint-Patrol-Rifle-Optic-PRO/">Aimpoint PRO</a> `,
				`<a href="https://www.trex-arms.com/store/law-folder-ar-m4-gen-3/">Law Tactical Folder</a> `,
				`<a href="https://www.trex-arms.com/store/New-Sling/">T.REX ARMS Sling</a> `,
			],
		},
	]

	let current_loadout

	$: current_index = loadouts.indexOf(current_loadout)

	let screenWidth = Infinity
	$: width = screenWidth > 800 ? 4 : 2

	onMount(() => {
		let resize = () => { screenWidth = window.innerWidth }
		resize()
		window.addEventListener(`resize`, resize)
		return () => { window.removeEventListener(`resize`, resize) }
	})
</script>

<div class="loadouts">
	{#each loadouts as loadout, i}
		<!-- svelte-ignore a11y-click-events-have-key-events a11y-no-static-element-interactions this is probably not okay, this should be a focusable/keyboard-interactive element -->
		<div class="loadout" class:active={current_loadout === loadout} on:click={() => { current_loadout = current_loadout === loadout ? false : loadout }}>
			<div class="expander"></div>
			<img alt="{loadout.name}" src="{loadout_img_prefix}{loadout.img}?auto=compress,format&w=300&dpr={typeof window !== `undefined` ? window.devicePixelRatio : 2}" />
		</div>
		{#if (((i + 1) % width === 0) || i === loadouts.length - 1) && Math.floor(current_index / width) === Math.floor(i / width) }
			<div class="info">
				<img src="{loadout_img_prefix}{current_loadout.img}?auto=compress,format&w=650&dpr={typeof window !== `undefined` ? window.devicePixelRatio : 2}" alt="{current_loadout.name}" />
				<div class="text">
					<h3>{current_loadout.name}</h3>
					<ul>
						{#each current_loadout.bullets as bullet}
							<li>{@html bullet}</li>
						{/each}
					</ul>
				</div>
			</div>
		{/if}
	{/each}
</div>

<style>
	.loadouts {
		display: flex;
		flex-wrap: wrap;
		padding: 5px;
	}
	.loadout {
		width: calc(25% - 10px);
		margin: 5px;
		text-decoration: none;
		position: relative;
		overflow: hidden;
		cursor: pointer;
	}
	.expander {
		padding-bottom: 66.6%;
	}
	.loadout > img {
		position: absolute;
		top: 0;
		max-width: 100%;
		display: block;
	}

	.info {
		width: 100%;
		display: flex;
		padding: 5px;
		align-items: start;
	}

	.info img {
		flex-grow: 1;
		flex-basis: 75%;
		width: 100%;
	}

	.info .text {
		padding: 10px 20px;
		flex-grow: 1;
		flex-basis: 25%;
	}

	.text li {
		list-style: none;
		font-size: 14px;
	}

	.text h3 {
		margin: 0 0 20px 0;
		padding: 0;
		line-height: 1.2;
		color: #fff;
	}

	@media(max-width: 800px) {
		.loadout {
			width: calc(50% - 10px);
		}

		.info {
			display: block;
		}

		.info img {
			width: 100%;
		}

		.info .text {
			padding: 10px 20px;
		}
	}
</style>
